import {ContentDuplicates} from '@entities/master-content/episode-view';
import {nameOf} from 'amc-common-components';

export enum MasterType {
	Episode = 'episode',
	Season = 'season',
	Franchise = 'franchise',
	Movies = 'movies',
	Universal = 'universal',
	FranchiseId = 'franchise_id',
	NonRL = 'non-master',
	Archived = 'archived',
	Unmatchable = 'unmatchable',
	LiveStream = 'live-stream',
	Links = 'links',
	Unmarked = 'unmarked',
}

/** Auxiliary 'MaterTypeDuplMatch' variable.' */
export const MaterTypeDuplMatch = {
	[nameOf<ContentDuplicates>('by_franchise')]: MasterType.Franchise,
	[nameOf<ContentDuplicates>('by_season')]: MasterType.Season,
	[nameOf<ContentDuplicates>('by_episode')]: MasterType.Episode,
};

/** Auxiliary 'MasterTypeSearchFields' variable.' */
export const MasterTypeSearchFields = {
	[MasterType.Episode]: 'EPISODE_NAME',
	[MasterType.Season]: 'SERIES_NAME',
	[MasterType.Franchise]: 'FRANCHISE_NAME',
	[MasterType.Movies]: 'EPISODE_NAME',
};

/** Auxiliary 'MasterTypeMark' variable.' */
export const MasterTypeMark = {
	[MasterType.Episode]: 'E',
	[MasterType.Season]: 'S',
	[MasterType.Franchise]: 'F',
	[MasterType.Movies]: 'M',
	[MasterType.Universal]: 'U',
	[MasterType.Links]: 'L',
};

export enum MasterSourceType {
	Global = 'GLOBAL',
	Test = 'TEST',
	RLJE = 'RLJE',
	RL = 'RL',
	Full = 'FULL',
}

/** Auxiliary 'DefaultFilterTypes' variable.' */
export const DefaultFilterTypes = [
	MasterType.Franchise,
	MasterType.Season,
	MasterType.Episode,
	MasterType.Movies,
	MasterType.Universal,
];
/** Auxiliary 'DefaultFilterTypesExtendedByLinks' variable.' */
export const DefaultFilterTypesExtendedByLinks = [
	MasterType.Franchise,
	MasterType.Season,
	MasterType.Episode,
	MasterType.Movies,
	MasterType.Links,
];
